import CascadedSelectForResponse from '../cascaded_select.js';
import CheckBoxForResponse from '../check_box.js';
import DateTimeForResponse from '../date_time.js';
import DetailForResponse from '../detail.js';
import FileForResponse from '../file.js';
import IntegerForResponse from '../integer.js';
import LocationForResponse from '../location.js';
import MemberForResponse from '../member.js';
import OrganizationForResponse from '../organization.js';
import RadioButtonForResponse from '../radio_button.js';
import RatingForResponse from '../rating.js';
import SectionBreakForResponse from '../section_break.js';
import TextFieldForResponse from '../text_field.js';
import TextAreaForResponse from '../text_area.js';
import CalculationForResponse from '../calculation.js';
import EsignatureForResponse from '../esignature.js';

import ResponseFieldListMixin from './mixin.js';

const FieldsForResponse = {
  CascadedSelectForResponse,
  CheckBoxForResponse,
  DateTimeForResponse,
  DetailForResponse,
  FileForResponse,
  IntegerForResponse,
  LocationForResponse,
  MemberForResponse,
  OrganizationForResponse,
  RadioButtonForResponse,
  RatingForResponse,
  SectionBreakForResponse,
  TextFieldForResponse,
  TextAreaForResponse,
  CalculationForResponse,
  EsignatureForResponse
};

const ResponseFieldListFieldable = Vue.extend({
  mixins: [ResponseFieldListMixin],

  methods: {
    _getComponent: function(field) {
      var type;

      type = field.type.demodulize();
      return FieldsForResponse[`${type}ForResponse`] || TextFieldForResponse;
    }
  }
});

export default ResponseFieldListFieldable;
